module.exports = __webpack_public_path__ + "static/media/sc_4_i.45ce345e.png";